<template>
    <div id="teclia_captcha_container" class="ml-2 mt-2"></div>
</template>

<script>
export default {
    mounted() {
        window.tecliaOnRecaptchaLoad = () => {
            grecaptcha.render('teclia_captcha_container', {
                sitekey: '6LcH_1AUAAAAABBAi87_aY7fMvuhiGzMeonFfaPX',
            })
        }

        let script = document.createElement('script')
        script.src = 'https://www.google.com/recaptcha/api.js?onload=tecliaOnRecaptchaLoad&render=explicit'
        document.head.appendChild(script)
    },
    methods: {
        getToken() {
            if (!grecaptcha) return false
            let response = grecaptcha.getResponse()
            if (!response) return false
            return response
        },
    },
}
</script>